import React, { useEffect } from 'react';
import classes from './index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';

import imgRps from '../../assets/imgs/projects/rock-paper-sicssor.jpg';
import imgCal from '../../assets/imgs/projects/calculator.jpg';
import imgBM from '../../assets/imgs/projects/beat-maker.jpg';
import imgAH from '../../assets/imgs/art-house/d-1.jpg';
import imgPho from '../../assets/imgs/photography/photography_1.jpg';
import imgDR from '../../assets/imgs/dotrun/dotrun_1.jpg';
import imgPL from '../../assets/imgs/p-light/p-light_1.jpg';
import imgPort from '../../assets/imgs/portfolio/p-1.jpg';

const projects = [
    {
        img: imgRps,
        name: 'Rock Paper Sicssor',
        liveLink: '',
        githubLink: ''
    },
    {
        img: imgCal,
        name: 'Calculator',
        liveLink: '',
        githubLink: ''
    },
    {
        img: imgBM,
        name: 'Beat Maker',
        liveLink: '',
        githubLink: ''
    },
    {
        img: imgAH,
        name: 'Art House',
        liveLink: '',
        githubLink: ''
    },
    {
        img: imgPho,
        name: 'Photography',
        liveLink: '',
        githubLink: ''
    },
    {
        img: imgDR,
        name: 'DotRun',
        liveLink: '',
        githubLink: ''
    },
    {
        img: imgPL,
        name: 'Portfolio Light',
        liveLink: '',
        githubLink: ''
    },
    {
        img: imgPort,
        name: 'Portfolio Multi Page',
        liveLink: '',
        githubLink: ''
    },
];

const ProjectsRoute = () => {
    useEffect(()=> {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={classes.ProjectsRoute}>
            <div className={[classes.Container, 'container'].join(' ')}>

                <div className={classes.Projects}>
                    {projects.map((project, i)=> (
                        <div className={classes.Project} key={i}>
                            <img src={project.img} alt="IMG" className={classes.img} />
                            <h3 className={classes.name}>{project.name}</h3>
                            <div className={classes.links}>
                                <hr className={classes.hr}/>
                                <a href={project.liveLink} className={classes.liveLink} target="_black">
                                <span className={classes.icon}>
                                    <FontAwesomeIcon icon={faLink} color="inherit" fontSize="inherit" />
                                </span>
                                Live Preview
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    )
}

export default ProjectsRoute

